module.exports = __webpack_public_path__ + "static/img/douyin.a0962e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/douyin.png
// module id = EHmA
// module chunks = 1